// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-grow: 0;
  justify-content: center;
  align-items: flex-start;
  background: var(--Colors-UI-Neutral-Grey-0, #F5F5F5);
  /* keep the header pinned to the top of the page */
  position: sticky;
  top: 0;
  z-index: 2;
}

.container {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-self: stretch;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  margin-bottom: 0;
  min-height: 50px;
  height: auto;
}

.container-left {
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}

.container-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ops-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #CCDCE4;
  border-radius: 999px;
  padding: 5px 10px;
  background: #FFFFFF;
  color: #184762;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  cursor: default;
}

.ops-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #7D96A8;
}

.ops-status-badge.state-loading .ops-status-dot {
  background: #D68C00;
}

.ops-status-badge.state-live .ops-status-dot {
  background: #1E8E3E;
}

.ops-status-badge.state-steady .ops-status-dot {
  background: #2E72B7;
}

.ops-status-badge.state-idle .ops-status-dot {
  background: #7D96A8;
}

.ops-status-badge.state-alert {
  border-color: #F2B8B5;
  color: #A5372B;
  background: #FFF5F4;
}

.ops-status-badge.state-alert .ops-status-dot {
  background: #B3261E;
}

.ops-status-badge.state-stale-version {
  border-color: #F2CC8F;
  color: #7A4700;
  background: #FFF8EC;
}

.ops-status-badge.state-stale-version .ops-status-dot {
  background: #D68C00;
}

.crumbbar {
  display: flex;
  gap: 8px;
}

.crumbbar-fixed-text-container {
  display: flex;
  height: 40px;
  align-items: center;
  gap: 24px;
  height: 48px;
}

.crumbbar-fixed-text {
  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);
  text-align: center;
  /* Web & Mobile/Title/Bold 22pt */
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 136.364% */
}

.hide {
  display: none;
}

:host(.ops-advanced) .container {
  align-items: flex-start;
  flex-wrap: wrap;
  padding-top: 8px;
  min-height: 50px;
  height: auto;
}

:host(.ops-advanced) .container-left {
  flex: 1 1 620px;
  min-width: 320px;
}

:host(.ops-advanced) .container-right {
  justify-content: flex-end;
  flex: 1 1 420px;
  flex-wrap: wrap;
  gap: 8px;
  position: relative;
}

:host(.ops-advanced) .crumbbar {
  flex-wrap: wrap;
}

.menu-wrapper {
  position: relative;
}

.menu-wrapper.menu-wrapper-sidebar {
  position: fixed;
  left: 20px;
  bottom: 92px;
  z-index: 50;
}

.menu-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  border: 1px solid #CCDCE4;
  border-radius: 32px;
  padding: 0;
  background: #fff;
  color: #4E758E;
  cursor: pointer;
}

.menu-button:hover {
  background: #F0F4F8;
}

.menu-button:active {
  background: #E0E8F0;
}

.menu-button-icon {
  width: 18px;
  height: 18px;
}

.menu-avatar-icon {
  width: 20px;
  height: 20px;
  border-radius: 999px;
}

.menu-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  min-width: 180px;
  background: #fff;
  border: 1px solid #CCDCE4;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(28, 28, 28, 0.15);
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 30;
}

.menu-wrapper.menu-wrapper-sidebar .menu-dropdown {
  left: calc(100% + 8px);
  right: auto;
  bottom: 0;
  top: auto;
}

.menu-dropdown.hide {
  display: none;
}

.menu-user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px 10px;
  position: relative;
  margin-bottom: 4px;
}

.menu-user-info::after {
  content: "";
  display: block;
  height: 1px;
  margin-top: 8px;
  background: linear-gradient(90deg, rgba(17, 62, 87, 0.18), rgba(17, 62, 87, 0.06));
}

.menu-user-label {
  color: #6A8598;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.menu-user-name {
  color: #184762;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  word-break: break-word;
}

.menu-user-pill {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  margin-top: 6px;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid #CCDCE4;
  background: #F7FAFC;
  color: #2B5D78;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.menu-version {
  margin-top: 4px;
  color: #6A8598;
  font-size: 11px;
  font-weight: 500;
}

.menu-version.hide {
  display: none;
}

.menu-item {
  display: flex;
  width: 100%;
  border: 0;
  border-radius: 8px;
  padding: 8px 10px;
  background: transparent;
  color: #184762;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
}

.menu-item.hide {
  display: none;
}

.menu-item:hover {
  background: #F0F4F8;
}

.menu-item.selected {
  background: #D9ECFA;
  color: #0B4E7A;
}

.menu-item.menu-status {
  align-items: center;
  gap: 8px;
  cursor: default;
}

.menu-item.menu-status .ops-status-dot {
  flex: 0 0 auto;
}

.menu-item.menu-status.state-stale-version {
  cursor: pointer;
}

.menu-item-danger {
  color: #A5372B;
}

.menu-item-danger:hover {
  background: #FCE8E6;
}

.feedback-modal {
  position: fixed;
  inset: 0;
  z-index: 120;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feedback-modal.hide {
  display: none;
}

.feedback-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
}

.feedback-panel {
  position: relative;
  z-index: 1;
  width: min(560px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  overflow: auto;
  border-radius: 14px;
  border: 1px solid #CCDCE4;
  background: #fff;
  box-shadow: 0 16px 40px rgba(28, 28, 28, 0.25);
}

.feedback-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #E4EBF0;
}

.feedback-title {
  color: #113E57;
  font-size: 18px;
  font-weight: 700;
}

.feedback-close {
  border: 0;
  background: transparent;
  color: #4E758E;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  border-radius: 6px;
  padding: 2px 6px;
}

.feedback-close:hover {
  background: #F0F4F8;
}

.feedback-body {
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feedback-label {
  color: #4E758E;
  font-size: 13px;
  font-weight: 700;
}

.feedback-input,
.feedback-select,
.feedback-textarea {
  border: 1px solid #CCDCE4;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  color: #123E58;
  background: #fff;
}

.feedback-input:focus,
.feedback-select:focus,
.feedback-textarea:focus {
  outline: none;
  border-color: #2E72B7;
  box-shadow: 0 0 0 2px rgba(46, 114, 183, 0.15);
}

.feedback-textarea {
  min-height: 140px;
  resize: vertical;
}

.feedback-status {
  min-height: 18px;
  color: #5B7285;
  font-size: 12px;
}

.feedback-status.success {
  color: #1E8E3E;
}

.feedback-status.error {
  color: #B3261E;
}

.feedback-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #E4EBF0;
}

.feedback-btn {
  border: 1px solid #CCDCE4;
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.feedback-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.feedback-btn-secondary {
  background: #fff;
  color: #4E758E;
}

.feedback-btn-secondary:hover:not(:disabled) {
  background: #F0F4F8;
}

.feedback-btn-primary {
  background: #2E72B7;
  border-color: #2E72B7;
  color: #fff;
}

.feedback-btn-primary:hover:not(:disabled) {
  background: #1C5C9F;
}

@media (max-width: 1280px) {
  :host(.ops-advanced) .container {
    gap: 6px;
  }

  :host(.ops-advanced) .container-right {
    gap: 6px;
  }
}

/* Upgrade modal */
.upgrade-modal {
  position: fixed;
  inset: 0;
  z-index: 120;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upgrade-modal.hide {
  display: none;
}

.upgrade-panel {
  position: relative;
  z-index: 1;
  width: min(620px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  overflow: auto;
  border-radius: 14px;
  border: 1px solid #CCDCE4;
  background: #fff;
  box-shadow: 0 16px 40px rgba(28, 28, 28, 0.25);
}

.upgrade-info {
  font-size: 13px;
  color: #4E758E;
  padding: 6px 0;
  line-height: 1.5;
}

.upgrade-branch-row {
  display: flex;
  gap: 6px;
  align-items: center;
}

.upgrade-branch-select {
  flex: 1;
}

.upgrade-branch-input {
  flex: 1;
}

.upgrade-branch-toggle {
  border: 1px solid #CCDCE4;
  border-radius: 8px;
  background: #fff;
  color: #4E758E;
  font-size: 16px;
  padding: 6px 10px;
  cursor: pointer;
  line-height: 1;
}

.upgrade-branch-toggle:hover {
  background: #F0F4F8;
}

.upgrade-branch-toggle.active {
  background: #E0EDFA;
  border-color: #2E72B7;
  color: #2E72B7;
}

.upgrade-log {
  max-height: 240px;
  overflow-y: auto;
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  font-size: 11px;
  line-height: 1.45;
  background: #1A2B38;
  color: #C8DCE8;
  border-radius: 8px;
  padding: 10px 12px;
  white-space: pre-wrap;
  word-break: break-all;
}

.upgrade-log.hide {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/header.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,oDAAoD;EACpD,kDAAkD;EAClD,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yDAAyD;EACzD,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sDAAsD;EACtD,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import url(\"./global.css\");\n\n:host {\n  display: flex;\n  flex-grow: 0;\n  justify-content: center;\n  align-items: flex-start;\n  background: var(--Colors-UI-Neutral-Grey-0, #F5F5F5);\n  /* keep the header pinned to the top of the page */\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.container {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  align-self: stretch;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n  margin-bottom: 0;\n  min-height: 50px;\n  height: auto;\n}\n\n.container-left {\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 38px;\n}\n\n.container-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.ops-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #CCDCE4;\n  border-radius: 999px;\n  padding: 5px 10px;\n  background: #FFFFFF;\n  color: #184762;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: default;\n}\n\n.ops-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #7D96A8;\n}\n\n.ops-status-badge.state-loading .ops-status-dot {\n  background: #D68C00;\n}\n\n.ops-status-badge.state-live .ops-status-dot {\n  background: #1E8E3E;\n}\n\n.ops-status-badge.state-steady .ops-status-dot {\n  background: #2E72B7;\n}\n\n.ops-status-badge.state-idle .ops-status-dot {\n  background: #7D96A8;\n}\n\n.ops-status-badge.state-alert {\n  border-color: #F2B8B5;\n  color: #A5372B;\n  background: #FFF5F4;\n}\n\n.ops-status-badge.state-alert .ops-status-dot {\n  background: #B3261E;\n}\n\n.ops-status-badge.state-stale-version {\n  border-color: #F2CC8F;\n  color: #7A4700;\n  background: #FFF8EC;\n}\n\n.ops-status-badge.state-stale-version .ops-status-dot {\n  background: #D68C00;\n}\n\n.crumbbar {\n  display: flex;\n  gap: 8px;\n}\n\n.crumbbar-fixed-text-container {\n  display: flex;\n  height: 40px;\n  align-items: center;\n  gap: 24px;\n  height: 48px;\n}\n\n.crumbbar-fixed-text {\n  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);\n  text-align: center;\n  /* Web & Mobile/Title/Bold 22pt */\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 30px; /* 136.364% */\n}\n\n.hide {\n  display: none;\n}\n\n:host(.ops-advanced) .container {\n  align-items: flex-start;\n  flex-wrap: wrap;\n  padding-top: 8px;\n  min-height: 50px;\n  height: auto;\n}\n\n:host(.ops-advanced) .container-left {\n  flex: 1 1 620px;\n  min-width: 320px;\n}\n\n:host(.ops-advanced) .container-right {\n  justify-content: flex-end;\n  flex: 1 1 420px;\n  flex-wrap: wrap;\n  gap: 8px;\n  position: relative;\n}\n\n:host(.ops-advanced) .crumbbar {\n  flex-wrap: wrap;\n}\n\n.menu-wrapper {\n  position: relative;\n}\n\n.menu-wrapper.menu-wrapper-sidebar {\n  position: fixed;\n  left: 20px;\n  bottom: 92px;\n  z-index: 50;\n}\n\n.menu-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  width: 32px;\n  border: 1px solid #CCDCE4;\n  border-radius: 32px;\n  padding: 0;\n  background: #fff;\n  color: #4E758E;\n  cursor: pointer;\n}\n\n.menu-button:hover {\n  background: #F0F4F8;\n}\n\n.menu-button:active {\n  background: #E0E8F0;\n}\n\n.menu-button-icon {\n  width: 18px;\n  height: 18px;\n}\n\n.menu-avatar-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 999px;\n}\n\n.menu-dropdown {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n  min-width: 180px;\n  background: #fff;\n  border: 1px solid #CCDCE4;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(28, 28, 28, 0.15);\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  z-index: 30;\n}\n\n.menu-wrapper.menu-wrapper-sidebar .menu-dropdown {\n  left: calc(100% + 8px);\n  right: auto;\n  bottom: 0;\n  top: auto;\n}\n\n.menu-dropdown.hide {\n  display: none;\n}\n\n.menu-user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 10px 10px;\n  position: relative;\n  margin-bottom: 4px;\n}\n\n.menu-user-info::after {\n  content: \"\";\n  display: block;\n  height: 1px;\n  margin-top: 8px;\n  background: linear-gradient(90deg, rgba(17, 62, 87, 0.18), rgba(17, 62, 87, 0.06));\n}\n\n.menu-user-label {\n  color: #6A8598;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.menu-user-name {\n  color: #184762;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.menu-user-pill {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  margin-top: 6px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  border: 1px solid #CCDCE4;\n  background: #F7FAFC;\n  color: #2B5D78;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.menu-version {\n  margin-top: 4px;\n  color: #6A8598;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.menu-version.hide {\n  display: none;\n}\n\n.menu-item {\n  display: flex;\n  width: 100%;\n  border: 0;\n  border-radius: 8px;\n  padding: 8px 10px;\n  background: transparent;\n  color: #184762;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: left;\n}\n\n.menu-item.hide {\n  display: none;\n}\n\n.menu-item:hover {\n  background: #F0F4F8;\n}\n\n.menu-item.selected {\n  background: #D9ECFA;\n  color: #0B4E7A;\n}\n\n.menu-item.menu-status {\n  align-items: center;\n  gap: 8px;\n  cursor: default;\n}\n\n.menu-item.menu-status .ops-status-dot {\n  flex: 0 0 auto;\n}\n\n.menu-item.menu-status.state-stale-version {\n  cursor: pointer;\n}\n\n.menu-item-danger {\n  color: #A5372B;\n}\n\n.menu-item-danger:hover {\n  background: #FCE8E6;\n}\n\n.feedback-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 120;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.feedback-modal.hide {\n  display: none;\n}\n\n.feedback-backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.feedback-panel {\n  position: relative;\n  z-index: 1;\n  width: min(560px, calc(100vw - 32px));\n  max-height: calc(100vh - 32px);\n  overflow: auto;\n  border-radius: 14px;\n  border: 1px solid #CCDCE4;\n  background: #fff;\n  box-shadow: 0 16px 40px rgba(28, 28, 28, 0.25);\n}\n\n.feedback-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid #E4EBF0;\n}\n\n.feedback-title {\n  color: #113E57;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.feedback-close {\n  border: 0;\n  background: transparent;\n  color: #4E758E;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 6px;\n  padding: 2px 6px;\n}\n\n.feedback-close:hover {\n  background: #F0F4F8;\n}\n\n.feedback-body {\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.feedback-label {\n  color: #4E758E;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.feedback-input,\n.feedback-select,\n.feedback-textarea {\n  border: 1px solid #CCDCE4;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 14px;\n  color: #123E58;\n  background: #fff;\n}\n\n.feedback-input:focus,\n.feedback-select:focus,\n.feedback-textarea:focus {\n  outline: none;\n  border-color: #2E72B7;\n  box-shadow: 0 0 0 2px rgba(46, 114, 183, 0.15);\n}\n\n.feedback-textarea {\n  min-height: 140px;\n  resize: vertical;\n}\n\n.feedback-status {\n  min-height: 18px;\n  color: #5B7285;\n  font-size: 12px;\n}\n\n.feedback-status.success {\n  color: #1E8E3E;\n}\n\n.feedback-status.error {\n  color: #B3261E;\n}\n\n.feedback-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #E4EBF0;\n}\n\n.feedback-btn {\n  border: 1px solid #CCDCE4;\n  border-radius: 10px;\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.feedback-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.feedback-btn-secondary {\n  background: #fff;\n  color: #4E758E;\n}\n\n.feedback-btn-secondary:hover:not(:disabled) {\n  background: #F0F4F8;\n}\n\n.feedback-btn-primary {\n  background: #2E72B7;\n  border-color: #2E72B7;\n  color: #fff;\n}\n\n.feedback-btn-primary:hover:not(:disabled) {\n  background: #1C5C9F;\n}\n\n@media (max-width: 1280px) {\n  :host(.ops-advanced) .container {\n    gap: 6px;\n  }\n\n  :host(.ops-advanced) .container-right {\n    gap: 6px;\n  }\n}\n\n/* Upgrade modal */\n.upgrade-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 120;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.upgrade-modal.hide {\n  display: none;\n}\n\n.upgrade-panel {\n  position: relative;\n  z-index: 1;\n  width: min(620px, calc(100vw - 32px));\n  max-height: calc(100vh - 32px);\n  overflow: auto;\n  border-radius: 14px;\n  border: 1px solid #CCDCE4;\n  background: #fff;\n  box-shadow: 0 16px 40px rgba(28, 28, 28, 0.25);\n}\n\n.upgrade-info {\n  font-size: 13px;\n  color: #4E758E;\n  padding: 6px 0;\n  line-height: 1.5;\n}\n\n.upgrade-branch-row {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.upgrade-branch-select {\n  flex: 1;\n}\n\n.upgrade-branch-input {\n  flex: 1;\n}\n\n.upgrade-branch-toggle {\n  border: 1px solid #CCDCE4;\n  border-radius: 8px;\n  background: #fff;\n  color: #4E758E;\n  font-size: 16px;\n  padding: 6px 10px;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.upgrade-branch-toggle:hover {\n  background: #F0F4F8;\n}\n\n.upgrade-branch-toggle.active {\n  background: #E0EDFA;\n  border-color: #2E72B7;\n  color: #2E72B7;\n}\n\n.upgrade-log {\n  max-height: 240px;\n  overflow-y: auto;\n  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;\n  font-size: 11px;\n  line-height: 1.45;\n  background: #1A2B38;\n  color: #C8DCE8;\n  border-radius: 8px;\n  padding: 10px 12px;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.upgrade-log.hide {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
